import { Component } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-global-lottie-loader',
  templateUrl: './global-lottie-loader.component.html',
  styleUrls: ['./global-lottie-loader.component.scss']
})
export class GlobalLottieLoaderComponent {

  options: AnimationOptions = {
    path: '../../../../assets/animation/animation.json',
  };

  animationCreated(animationItem: AnimationItem): void {
  }
}
